export interface Notification
{
    id: string;
    icon?: string;
    image?: string;
    title?: string;
    event?: string;
    sentAt: string;
    content: string;
    objectContent: any;
    to: string;
    link?: string;
    useRouter?: boolean;
    read: boolean;
    priority: string;
    reason: string;
    type: string;
    dataType: number;
    notificationType: number;
    terminal: string;
}

export enum EventTypeEnum {
    ATA = "ATA",
    ATB = "ATB",
    ATS = "ATS",
    ETA = "ETA",
    ETS = "ETS",
    ETB = "ETB",
    POB_DEPARTURE = "POB DEPARTURE",
    POB_BERTHING = "POB BERTHING",
    POB_CANCELLED = "POB CANCELLED"
  }